import fetchCreator from "../utils/fetchCreator";

const client = new fetchCreator();

export const fetchZones = () =>
  client.get("zones").then((data: any) => data.data.zones);
